import $ from 'jquery';

export const PXHeader = (function() {
	'use strict';

	var $menu,
		$menuItem,
		$menuButton;

	function init() {

		$menu = $('.site-header__menu'),
		$menuItem = $('#menu-main-menu a'),
		$menuButton = $('.mobile-menu-button');

		events();
	}

	function events() {

		$menuButton.click(function(){

			if($menu.hasClass('open')){
				$menu.add($menuButton).removeClass('open');
			} else {
				$menu.add($menuButton).addClass('open');
			}
		});

		$menuItem.click(function(){
			if($(window).width() < 769){
				$menu.add($menuButton).removeClass('open');
			}
		});
	}

	return {
		init:init
	};
}());
